import script from "./SubMenuItem.vue?vue&type=script&setup=%7Bname%3A%20'SubMenuItem'%7D&lang=ts"
export * from "./SubMenuItem.vue?vue&type=script&setup=%7Bname%3A%20'SubMenuItem'%7D&lang=ts"

const __exports__ = script;

export default __exports__